<div class="top-pane__container" [class.top-pane__container--active]="contextDrawerOpen">
    <ng-content></ng-content>
</div>
<div class="top-pane__handle" (click)="toggleContextDrawer()"></div>
